import * as React from 'react'
import styled from 'styled-components'
import theme from 'theme'
import StarRating from 'theme/atoms/StarRating'
import LocationIcon from 'assets/location.svg'
import CallenderIcon from 'assets/date.svg'
import useTranslations from 'hooks/useTranslations'
import * as t from './types'
import { LocaleWithUnderscore } from 'config/config.type'

export default function SliderItem(props: t.Review) {
  const t = useTranslations<'organisms-service-review-slider'>()
  const username = props.reviewer.firstName
    ? `${props.reviewer.firstName} ${props.reviewer.lastName}`
    : t('service_reviews_verified_buyer')
  const date = new Date(props.createdAt).toLocaleDateString()
  const locationEnding = props.locale.replace('-', '_') as LocaleWithUnderscore

  return (
    <Wrapper className="SliderItem" data-cy-ctx="organisms/ServiceReviewSlider">
      <StarRating ratingAverage={props.rating} />
      <div className="author">{username}</div>
      <div className="date-locale">
        <div className="information">
          <CallenderIcon />
          <div className="date">{date}</div>
        </div>
        <div className="information">
          <LocationIcon />
          <div className="locale">
            {props.locale && t(`service_reviews_location_${locationEnding}`)}
          </div>
        </div>
      </div>
      {props.originalReview.title?.trim() !=
        props.originalReview.comment?.trim() && (
        <div className="title" data-cy-state="show-review-title">
          {props.originalReview.title}
        </div>
      )}
      <div className="comment" data-cy-state="show-comment">
        {props.originalReview.comment}
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing('xxs')};
  min-width: 16.375rem;
  @media (min-width: ${theme.ms.MD}px) {
    min-width: 21.125rem;
  }

  margin-right: ${theme.spacing('xs')};
  @media (min-width: ${theme.ms.MD}px) {
    margin-right: ${theme.spacing('s')};
  }
  > .author {
    color: ${theme.colors.dark_gray};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${theme.ty('rc-xs', null, 'rc-s')};
  }
  > .date-locale {
    display: flex;
    flex-direction: row;
    gap: ${theme.spacing('xs')};
    color: ${theme.colors.dark_gray};
    ${theme.ty('rc-xs', null, 'rc-s')};
    > .information {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: ${theme.spacing('xxs')};
      > svg {
        scale: 0.8;
        @media (min-width: ${theme.ms.MD}px) {
          scale: 1;
        }
      }
    }
  }
  > .title {
    ${theme.ty('rc-s', 'bold', 'rc-base')};
    gap: ${theme.spacing('xxs')};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  > .comment {
    ${theme.ty('r-s', null, 'r-base')};
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    text-overflow: ellipsis;
  }
`
